<template>
    <div :class="field.classes" class="col flex-item no-padding span_6_of_12 span_6_of_12-tl span_6_of_12-tp span_6_of_12-sl span_12_of_12-sp mb-2rem">
        <div class="learnworlds-overline-text learnworlds-element no-margin-bottom">
            {{ name }}
        </div>

        <input ref="inputField"
                :type="field.type"
               :name="field.name"
               :min="field.min"
               :max="field.max"
               :value="value"                              
               @input="update"
               @change="update"
               :class="inputClass"
               class="learnworlds-input-solid-light learnworlds-input learnworlds-input-normal learnworlds-element"
               :placeholder="name"/>

         <div v-if="error" class="learnworlds-main-text learnworlds-main-text-small learnworlds-element lw-brand-text">
            {{ error }}
        </div>
    </div>

</template>

<script>
    import FieldMixin from "./FieldMixin";
    
    export default {
        name: "InputFieldComponent",

        mixins: [
            FieldMixin
        ],
        
        mounted() {
            if (this.field.type === 'date') {
                const _this = this;
                const datePickerOptions = {
                    selectMonths: true,
                    selectYears: 60,
                    container: 'body',
                    format:"yyyy-mm-dd",
                    onOpen: function() {
                        $(".picker__box").show()
                    },
                    onClose: function() {
                        $(".picker__box").hide()
                    },
                    onSet: function(thingSet) {                                           
                      _this.$emit('input', this.get('select', 'yyyy-mm-dd'));
                    }
                };

                //Check if it is birthday field
                if(this.field.name === 'birthday'){
                    const registrationMinAge = (typeof window.registrationMinAge !== 'undefined' )? window.registrationMinAge : 14;
                    const maxDate = new Date(new Date().setFullYear(new Date().getFullYear() - registrationMinAge ));
                    datePickerOptions['max'] = maxDate;
                }

                $(this.$refs["inputField"]).pickadate(datePickerOptions);
                //fix flickering datepicker bug
                this.$refs["inputField"].addEventListener('mousedown', (e)=> {
                    e.preventDefault();
                })

            }
        }
    }
</script>
